import {
  ActionBarContext,
  ModalService,
  addActionBarItem,
} from '@vendure/admin-ui/core';
import { firstValueFrom } from 'rxjs';

import { PricingRuleDataService } from './pricing-rule-data.service';
import { PricingRuleImportDialogComponent } from './pricing-rule-import-dialog.component';

export default [
  addActionBarItem({
    id: 'import-pricing-rules',
    label: 'Import',
    locationId: 'promotion-list',
    buttonStyle: 'outline',
    icon: 'upload',
    onClick: async (event, context: ActionBarContext) => {
      const modalService = context.injector.get(ModalService);

      await firstValueFrom(
        modalService.fromComponent(PricingRuleImportDialogComponent),
      );
    },
  }),
  addActionBarItem({
    id: 'export-pricing-rules',
    label: 'Export',
    locationId: 'promotion-list',
    buttonStyle: 'outline',

    icon: 'download',
    onClick: (event, context: ActionBarContext) => {
      const pricingRuleDataService = context.injector.get(
        PricingRuleDataService,
      );
      pricingRuleDataService.exportPricingRulesToCsv();
    },
  }),
];
